/**
 * Session Selectors
 *
 * Memoized selectors for accessing session state.
 */
import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from '@/store/store';

const selectSessionState = (state: RootState) => state.session;

export const selectIsSessionReady = createSelector(
  [selectSessionState],
  (session) => session.isReady,
);

export const selectIsSessionInitializing = createSelector(
  [selectSessionState],
  (session) => session.isInitializing,
);

export const selectSessionError = createSelector([selectSessionState], (session) => session.error);
